import apiFn from 'common/services/api-service';

export const VIEW_ACTIVE = 'active';
export const VIEW_ARCHIVED = 'archived';

const api = eventId =>
  apiFn(`/api/uapi/organizer/events/${eventId}/discount-codes`, {
    Accept: 'application/vnd.eventmobi+json; version=p.10',
  });

export function list(eventId, payload = {}, queryParams = {}) {
  const params = new URLSearchParams(queryParams);

  if (payload.offset > 0) {
    params.set('page', payload.offset / payload.limit);
  }

  if (payload.isArchived !== undefined) {
    params.set('isArchived', payload.isArchived);
  }

  return api(eventId)
    .get('', { params })
    .then(response => response.data);
}

export const get = async (eventId, id) =>
  api(eventId)
    .get(id, { params: { include: 'actions' } })
    .then(response => response.data.data);

export function create(eventId, params) {
  return api(eventId)
    .post('', params)
    .then(response => response.data.data);
}

export function update(eventId, id, params) {
  return api(eventId)
    .patch(id, params)
    .then(response => response.data.data);
}

export async function getCounts(eventId) {
  const [activeCount, archivedCount] = (
    await Promise.all([
      list(eventId, { isArchived: false }, { limit: 0 }),
      list(eventId, { isArchived: true }, { limit: 0 }),
    ])
  ).map(res => res.meta.pagination.totalItemsCount);

  return [activeCount, archivedCount];
}
